import styled from "styled-components";

const StyledEspace = styled.section`
    background: linear-gradient(90deg, #e6f7ff, #b3e0ff);
    padding: 50px 30px;
    color: #2c5c5c;
`;

const EspaceWrapper = styled.div`
    max-width: 900px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    gap: 50px;
`;

const BoxVidéo = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* aspect ratio 16:9 */
    margin-bottom: 20px;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
`;

const CadreStylisé = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
`;

const TexteDescription = styled.p`
    font-size: 20px;
    line-height: 1.8;
    color: #2c5c5c;
    margin-top: 20px;
`;

const BoîteFormulaire = styled.div`
    background: rgba(255, 255, 255, 0.9);
    padding: 35px;
    border-radius: 15px;
    text-align: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
`;

const FormulaireInput = styled.form`
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const ChampInput = styled.input`
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 18px;
    transition: border-color 0.3s;

    &:focus {
        border-color: #66b3ff;
        outline: none;
    }
`;

const BoutonSoumettre = styled.button`
    padding: 16px;
    background-color: #66b3ff;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #3399ff;
    }
`;

const BoîteAccord = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #2c5c5c;
    margin-top: 15px;
    text-align: left;

    input[type="checkbox"] {
        margin-right: 10px;
    }

    a {
        color: #66b3ff;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const InfinityComponent = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        fetch("thanks/index.php", {
            method: "POST",
            body: formData,
        }).catch((error) => {
            console.error("Fehler beim Senden des Formulars:", error);
        });

        alert("Anfrage gesendet");
        e.target.reset();
    };

    return (
        <StyledEspace>
            <EspaceWrapper>
                <div>
                    <BoxVidéo>
                        <CadreStylisé
                            src="https://www.youtube.com/embed/3Fnp03rugL4?si=rIFhJ1oyLi6A_-31"
                            title="Troniq.news Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </BoxVidéo>
                    <TexteDescription>
                        Troniq.news ist eine Plattform, die künstliche Intelligenz nutzt, um die neuesten Nachrichten und Trends in der Technologie zu liefern. Sie verbindet Kreativität, Innovation und Technologie, um den Nutzern ein einzigartiges Erlebnis zu bieten. Entdecken Sie mit uns die Zukunft der Nachrichten und erleben Sie, wie KI die Art und Weise verändert, wie wir Informationen konsumieren und verstehen.
                    </TexteDescription>
                </div>
                <BoîteFormulaire>
                    <h3 style={{ marginBottom: "25px", color: "#2c5c5c" }}>Anmeldung</h3>
                    <FormulaireInput onSubmit={handleSubmit}>
                        <ChampInput
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Geben Sie Ihren Namen ein"
                            required
                        />
                        <ChampInput
                            type="text"
                            id="surname"
                            name="surname"
                            placeholder="Geben Sie Ihren Vornamen ein"
                            required
                        />
                        <ChampInput
                            type="email"
                            id="email"
                            name="email"
                            placeholder="beispiel@mail.com"
                            required
                        />
                        <ChampInput
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="+49 600 000 000"
                            required
                        />
                        <BoîteAccord>
                            <input type="checkbox" id="terms" name="terms" required />
                            <label htmlFor="terms">
                                Ich akzeptiere die{" "}
                                <a href="/terms" rel="noopener noreferrer">
                                    Allgemeinen Geschäftsbedingungen
                                </a>{" "}
                                und die{" "}
                                <a href="/cookies" rel="noopener noreferrer">
                                    Cookie-Richtlinie
                                </a>
                                sowie die{" "}
                                <a href="/policy" rel="noopener noreferrer">
                                    Datenschutzrichtlinie
                                </a>
                            </label>
                        </BoîteAccord>
                        <BoutonSoumettre type="submit">Anfrage einreichen</BoutonSoumettre>
                    </FormulaireInput>
                </BoîteFormulaire>
            </EspaceWrapper>
        </StyledEspace>
    );
};
export default InfinityComponent;